<script lang="ts">
  import { pageStore } from '@packages/stores'
  import { Pages } from '@packages/utils/enums'
  import { NavMenu } from '@packages/ui'

  const handleNavigate = (page: Pages) => {
    pageStore.set(page)
  }
</script>

<NavMenu
  options={{
    onClick: handleNavigate,
    showAssets: false,
  }}
/>
